export type AiConfidenceTriageState = "open" | "acknowledged";

export type AiConfidenceSortBy = "urgency" | "checkedOn" | "marketplace";

export const AI_CONFIDENCE_SEVERITY = {
	OK: 0,
	LOW: 1,
	MEDIUM: 2,
	HIGH: 3,
	CRITICAL: 4,
	CHECK_ERROR: 5,
} as const;

export type AiConfidenceSeverity = (typeof AI_CONFIDENCE_SEVERITY)[keyof typeof AI_CONFIDENCE_SEVERITY];

export interface AiConfidenceRow {
	mappingEventId: number;
	severity: AiConfidenceSeverity;
	issueCode: string | null;
	issueDetail: string | null;
	checkedOn: string | null;
	triageState: AiConfidenceTriageState;
	triageReason: string | null;
	triagedBy: string | null;
	triagedAt: string | null;
	rootCauseOwner: string;
	mappedBy: string;
	sfEventId: number | null;
	sfEventName: string | null;
	sfDate: string | null;
	sfTime: string | null;
	sfVenue: string | null;
	sfCity: string | null;
	sfState: string | null;
	marketplaceId: number;
	marketplace: string | null;
	marketplaceEventId: string;
	marketplaceEventName: string | null;
	marketplaceDate: string | null;
	marketplaceVenue: string | null;
	marketplaceCity: string | null;
	marketplaceState: string | null;
	ticketQty: number | null;
	soldQty: number | null;
}

export interface AiConfidenceSummary {
	criticalCount: number;
	highCount: number;
	mediumCount: number;
	lowCount: number;
	okCount: number;
	checkErrorCount: number;
	lastCheckedOn: string | null;
}

export interface AiConfidenceQueueResponse {
	total: number;
	page: number;
	pageSize: number;
	items: Array<AiConfidenceRow>;
	summary: AiConfidenceSummary;
	ticketsOnFlaggedMappings: number;
}

export interface AiConfidenceHealth {
	lastCheckedOn: string | null;
	checkErrorsLastDay: number;
	isHealthy: boolean;
}

export interface ListAiConfidenceParams {
	page: number;
	pageSize: number;
	severities?: Array<AiConfidenceSeverity>;
	marketplaceId?: number;
	triageState?: AiConfidenceTriageState;
	searchTerm?: string;
	sortBy?: AiConfidenceSortBy;
	sortDirection?: "asc" | "desc";
}

export type AiConfidenceBulkAction = "acknowledge" | "recheck";

export interface BulkAiConfidenceParams {
	action: AiConfidenceBulkAction;
	severities?: Array<AiConfidenceSeverity>;
	marketplaceId?: number;
	triageState?: AiConfidenceTriageState;
	searchTerm?: string;
	reason?: string;
	expectedCount: number;
}

export interface BulkAiConfidenceResult {
	action: AiConfidenceBulkAction;
	matched: number;
	applied: number;
	failed: number;
}
